import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/ConfigPrinterPage.css";
import { api } from "../features/apiServices/apiClient";
import safeJSON from "../components/safeJSON";
import ModalMesaClick from "../components/ModalMesaClick";


const ConfigPrinterPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");
  const activeRestaurant = safeJSON("activeRestaurant");
  const tenant = safeJSON("tenant");
  const user = safeJSON("user");



  //const tenant = JSON.parse(localStorage.getItem("tenant"));
  //const user = JSON.parse(localStorage.getItem("user"));
  //const activeRestaurant = JSON.parse(localStorage.getItem("activeRestaurant"));


  const [modal, setModal] = useState({ open: false, message: "" });
  const showModal = (message) => setModal({ open: true, message });

  const [pairingInProgress, setPairingInProgress] = useState(false);
  const [pairingTabletId, setPairingTabletId] = useState(null);

  const [printers, setPrinters] = useState([]);
  const [newPrinter, setNewPrinter] = useState({
    type: "ip",
    ip_address: "",
    usb_port: "",
    model: "",
  });

  const [tablets, setTablets] = useState([]);
  const [tabletNew, setTabletNew] = useState({
    name: "",
  });

  const [pairingCode, setPairingCode] = useState(null);

  const [restaurantConfig, setRestaurantConfig] = useState({
    nome: "",
    cnpj: "",
    quantidade_mesas: "",
  });

  // ------ Carregar configurações existentes ------
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) return;

    loadPrinters();
    loadTablets();
    loadRestaurant();
  }, []);

  useEffect(() => {
    if (!pairingInProgress || !pairingTabletId) return;

    const interval = setInterval(async () => {
      try {
        const res = await api.get("/tablets", {
          params: { restaurant_id: activeRestaurant.id },
        });

        setTablets(res.data);

        const pairedTablet = res.data.find(
          (t) => t.id === pairingTabletId && t.paired
        );

        if (pairedTablet) {
          setPairingInProgress(false);
          setPairingCode(null);
          setPairingTabletId(null);
          clearInterval(interval);
        }
      } catch (err) {
        console.error("Erro no polling de tablets", err);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [pairingInProgress, pairingTabletId, activeRestaurant]);

  const loadPrinters = async () => {
    try {
      const res = await api.get("/printers");
      setPrinters(res.data || []);
    } catch { }
  };

  const loadTablets = async () => {
    if (!activeRestaurant?.id) return;

    try {
      const res = await api.get("/tablets", {
        params: {
          restaurant_id: activeRestaurant.id,
        },
      });

      setTablets(res.data);
    } catch (error) {
      console.error("Erro ao carregar tablets:", error);
    }
  };

  const generatePairingCode = async () => {
    if (!tabletNew.name) {
      showModal("Informe o nome do tablet.");
      return;
    }

    try {
      const res = await api.post("/tablets/pairing-code", {
        restaurant_id: activeRestaurant.id,
        name: tabletNew.name,
      });

      setPairingCode(res.data.device_code);
      setPairingTabletId(res.data.tablet_id);
      setPairingInProgress(true);
      loadTablets();
    } catch (err) {
      showModal("Erro ao gerar código de pareamento.");
    }
  };

  const loadRestaurant = async () => {
    try {
      const res = await api.get("/restaurant/me");
      setRestaurantConfig(res.data);
    } catch { }
  };

  // ------ Deletar Impressora ------
  const deletePrinter = async (id) => {
    try {
      await api.delete(`/printers/${id}`);
      showModal("Impressora removida com sucesso.");
      loadPrinters();
    } catch {
      showModal("Erro ao remover impressora.");
    }
  };

  // ------ Salvar Impressora ------
  const savePrinter = async () => {
    try {
      await api.post("/printers", newPrinter);
      showModal("Impressora cadastrada!");
      setNewPrinter({ type: "ip", ip_address: "", usb_port: "", model: "" });
      loadPrinters();
    } catch (err) {
      showModal(err.response?.data?.error || "Erro ao salvar impressora.");
    }
  };

  const testPrinter = async (id) => {
    try {
      await api.post("/printer/test", { id });
      showModal("Teste enviado com sucesso!");
    } catch (err) {
      showModal(err.response?.data?.error || "Erro ao testar impressora.");
    }
  };

  // ------ Deletar Tablet ------
  const deleteTablet = async (id) => {
    try {
      await api.delete(`/tablets/${id}`);
      showModal("Tablet removido com sucesso.");
      loadTablets();
    } catch {
      showModal("Erro ao remover tablet.");
    }
  };

  // ------ Registrar Tablet ------
  const saveTablet = async () => {
    try {
      await api.post("/tablets", tabletNew);
      showModal("Tablet registrado!");
      loadTablets();
    } catch {
      showModal("Erro ao registrar tablet.");
    }
  };

  // ------ Salvar Restaurante ------
  const saveRestaurant = async () => {
    try {
      await api.put("/restaurant/update", restaurantConfig);
      showModal("Configurações salvas!");
    } catch {
      showModal("Erro ao salvar configurações.");
    }
  };

  return (
    <div className="printer-container">
      {/* HEADER */}
      <header className="printer-header">
        <img
          src="/assets/logo-mesaclick.png"
          alt="MesaClick"
          className="menus-logo"
          onClick={() => navigate("/home")}
        />
        <h1 className="header-title">Dispositivos - {activeRestaurant.nome}</h1>
      </header>

      <div className="split-container">
        {/* =======================
        LEFT FORM
  ======================= */}
        <div className="left-pane">
          {/* IMPRESSORA */}
          <h2 className="section-title">Configurar Impressora</h2>

          <div className="form-section">
            <div className="form-group">
              <label className="label">Tipo</label>
              <select
                className="input"
                value={newPrinter.type}
                onChange={(e) =>
                  setNewPrinter({ ...newPrinter, type: e.target.value })
                }
              >
                <option value="ip">IP (Rede)</option>
                <option value="usb">USB</option>
              </select>
            </div>

            {newPrinter.type === "ip" ? (
              <div className="form-group">
                <label className="label">Endereço IP</label>
                <input
                  className="input"
                  type="text"
                  value={newPrinter.ip_address}
                  onChange={(e) =>
                    setNewPrinter({ ...newPrinter, ip_address: e.target.value })
                  }
                  placeholder="192.168.0.20"
                />
              </div>
            ) : (
              <div className="form-group">
                <label className="label">Porta USB</label>
                <input
                  className="input"
                  type="text"
                  value={newPrinter.usb_port}
                  onChange={(e) =>
                    setNewPrinter({ ...newPrinter, usb_port: e.target.value })
                  }
                  placeholder="USB001"
                />
              </div>
            )}

            <div className="form-group">
              <label className="label">Nome / Modelo</label>
              <input
                className="input"
                type="text"
                value={newPrinter.model}
                onChange={(e) =>
                  setNewPrinter({ ...newPrinter, model: e.target.value })
                }
                placeholder="Ex: Cozinha - Epson TM-T20"
              />
            </div>

            <div className="form-buttons">
              <button className="btn-save" onClick={savePrinter}>
                Adicionar
              </button>
            </div>
          </div>

          {/* TABLET */}
          <h2 className="section-title">Parear Tablet</h2>

          <div className="form-section">
            <p className="pairing-hint" style={{ marginBottom: 12 }}>
              Para usar o tablet como cardápio, instale o app <strong>MesaClick</strong> na loja de aplicativos:
              <br />
              <a href="https://play.google.com/store/apps/details?id=com.mesaclick.app" target="_blank" rel="noreferrer">
                📲 Google Play Store
              </a>
            </p>

            <div className="form-group">
              <label className="label">Nome do Tablet</label>
              <input
                className="input"
                type="text"
                value={tabletNew.name}
                onChange={(e) =>
                  setTabletNew({ ...tabletNew, name: e.target.value })
                }
                placeholder="Ex: Tablet Salão 01"
              />
            </div>

            <div className="form-buttons">
              <button className="btn-save" onClick={generatePairingCode}>
                Gerar código de pareamento
              </button>
            </div>

            {pairingCode && (
              <div className="pairing-code-box">
                <p className="pairing-label">Código de pareamento</p>
                <div className="pairing-code">{pairingCode}</div>
                <p className="pairing-hint">
                  Digite este código no tablet para finalizar o pareamento.
                </p>
              </div>
            )}
          </div>
        </div>

        {/* =======================
        RIGHT LISTS
  ======================= */}
        <div className="right-pane">
          {/* LISTA IMPRESSORAS */}
          <h2 className="section-title">Impressoras adicionadas</h2>

          <div className="rest-list">
            {printers.length === 0 ? (
              <p className="empty-text">Nenhuma impressora cadastrada.</p>
            ) : (
              printers.map((p) => (
                <div key={p.id} className="rest-card">
                  <div className="rest-card-info">
                    <div className="rest-name">{p.model || "Impressora"} — {p.type.toUpperCase()}</div>
                    <div className="rest-info">{p['interface'] || p.ip_address || p.usb_port}</div>
                  </div>
                  <div className="rest-card-actions">
                    <button className="btn-save" onClick={() => testPrinter(p.id)}>Testar</button>
                    <button className="btn-danger" onClick={() => deletePrinter(p.id)}>Remover</button>
                  </div>
                </div>
              ))
            )}
          </div>

          <hr className="divider" />

          {/* LISTA TABLETS */}
          <h2 className="section-title">Tablets cadastrados</h2>

          <div className="rest-list">
            {tablets.length === 0 && (
              <p className="empty-text">Nenhum tablet cadastrado.</p>
            )}

            {tablets.map((t) => (
              <div key={t.id} className="rest-card">
                <div className="rest-card-info">
                  <div className="rest-name">{t.name}</div>
                  <div className="rest-info">
                    Status: {t.paired ? "Pareado" : "Aguardando pareamento"}
                  </div>
                </div>
                <div className="rest-card-actions">
                  <button className="btn-danger" onClick={() => deleteTablet(t.id)}>
                    Remover
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ModalMesaClick
        open={modal.open}
        message={modal.message}
        onClose={() => setModal({ open: false, message: "" })}
      />
    </div>
  );
};

export default ConfigPrinterPage;
